import { ShieldCheck, Prohibit, EnvelopeSimple, Database } from '@phosphor-icons/react';
import { PageHeader } from '../components/PageHeader';
import { RevealOnScroll } from '../components/motion/RevealOnScroll';
import { SpotlightCard } from '../components/motion/SpotlightCard';

const commitments = [
  {
    icon: Prohibit,
    title: 'We don’t learn from your data',
    body: 'We don’t train models on your emails, and we don’t use them to improve any product beyond generating your own follow-ups.',
  },
  {
    icon: ShieldCheck,
    title: 'We don’t share it',
    body: 'Your email content is never sold, shared, or handed to third parties, advertisers, or data brokers.',
  },
  {
    icon: EnvelopeSimple,
    title: 'One purpose, nothing else',
    body: 'The only thing we do with an email is read it to figure out what follow-up it needs, then draft and send that follow-up.',
  },
  {
    icon: Database,
    title: 'Kept only as long as needed',
    body: 'Email content is retained only for as long as it takes to track and complete the follow-up it relates to.',
  },
];

export function PrivacyPage() {
  return (
    <>
      <PageHeader
        eyebrow="Data privacy"
        title="Your inbox is not our product"
        subtitle="When you CC us on an email, we read it for one reason: to chase the follow-up for you. Nothing more."
      />

      <section className="py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid gap-5 sm:grid-cols-2">
            {commitments.map((item) => (
              <RevealOnScroll key={item.title}>
                <SpotlightCard className="h-full rounded-xl border border-white/10 bg-white/[0.04] p-6 hover:border-white/20 transition-colors duration-300">
                  <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-indigo-500/15">
                    <item.icon weight="bold" className="h-5 w-5 text-indigo-300" />
                  </div>
                  <h3 className="mt-4 font-semibold text-zinc-100 text-lg">{item.title}</h3>
                  <p className="mt-2 text-sm text-zinc-400">{item.body}</p>
                </SpotlightCard>
              </RevealOnScroll>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16">
        <RevealOnScroll className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-8 sm:p-10 space-y-6 text-zinc-400">
            <div>
              <h2 className="text-xl font-semibold text-zinc-100 mb-2">What we actually do with your emails</h2>
              <p>
                When you CC Chase it for me on a message, our system reads it to understand what you’re
                waiting on and when a reply is expected. That understanding is used only to track the
                follow-up, draft reminder emails, and send them on your behalf. That’s the entire purpose.
              </p>
            </div>
            <div>
              <h2 className="text-xl font-semibold text-zinc-100 mb-2">What we don’t do</h2>
              <p>
                We don’t use your email content to train AI models, we don’t share it with advertisers or
                other companies, and we don’t repurpose it for anything outside of running your follow-ups.
              </p>
            </div>
            <div>
              <h2 className="text-xl font-semibold text-zinc-100 mb-2">Questions</h2>
              <p>
                If you have any questions about how your data is handled, reach out to us and we’ll be happy
                to walk you through it.
              </p>
            </div>
          </div>
        </RevealOnScroll>
      </section>
    </>
  );
}
